import { useWeb3React } from "@web3-react/core";
import { useCallback, useMemo } from "react";
import Environment from "../../utils/Environment";
import useWeb3 from "../useWeb3";
import { getVestingContract } from "../../utils/contractHelpers";

import Web3 from "web3";

const useAirdrops = () => {
  // const web3 = useWeb3();
  const web3 = new Web3(
    "https://dry-quiet-sound.arbitrum-mainnet.quiknode.pro/ec48bb1798a955bcdf75c64bc9fab428add0745e/"
  );

  const vestingContractInstance = getVestingContract(Environment.Vesting, web3);

  const airdrops = useCallback(
    async (account) => {
      if (!vestingContractInstance || !account) return "0";
      try {
        const airdropResponse = await vestingContractInstance.methods
          .airdrops(account)
          .call();

        console.log("airdropResponse: ", airdropResponse);

        return airdropResponse;
      } catch (error) {
        console.error("Error fetching airdropResponse", error);
        throw error;
      }
    },
    [vestingContractInstance]
  );

  return airdrops;
};

export default useAirdrops;
